<template>
  <div class="app-container"  @click="hidePannel()">
	  
	<!-- 时钟 -->
   <div class="clock">    
       <clock :time="time"   bg="radial-gradient(circle, #ecffe5, #ffffff, #f9ffcd)"></clock> 
   </div>
   <!-- 在线咨询 -->
  <div class="online" @click="openUrl('/main/zxzxForm')"/>      
  <!-- 导航面板 -->
   <div class="nvlPannel" >  
	   <el-row>
	     <el-col :span="6"
		 v-for="(item, index) in pannelList" > 
		    <div class="content"   v-show="isActive==item.name"  >				 
			    <h4>{{item.name}}</h4>
				 <el-row :gutter="5"> 
					<el-col style="margin-bottom: 5px;text-align: left;":span="12"  v-for="(itemchild, index) in item.labels" >
						<el-button @click="openUrl(itemchild.url)" size="mini" type="primary">{{itemchild.label}}
						</el-button>
					</el-col>
				</el-row>
		    </div>			 
			<!-- 虚拟dom,用来空置div高度的。当display=none时，浏览器高度为0  用其他办法吗？？？？-->
			<div  style="height: 165px;"    v-show="isActive!=item.name"/>	
			<!-- 热点区域选择div -->
		    <div style="height: 120px"  @mouseover="showPannel(item.name)">				
			</div>
		  </el-col>
	      
	   </el-row>
   </div>
 
 
   
  </div>
</template>

<script>
 
    import Clock from 'vue-clock2';
  export default {
    name: "Xwqycx",
	components: {
	 Clock
	
	},
    data() {
      return {
        // 遮罩层
        loading: true,
        // 总条数
        total: 0,        
        // 是否显示弹出层
        open: false,
        // 查询参数
         time: undefined,
		 
		 pannelList:[
           {
            name: '知识产权综合服务',
			labels:[
					{label:'法律法规政策',url:'/main/zscqzhfw/flfgzc'},
					{label:'知识产权服务联盟',url:'/main/zscqzhfw/fwlmjj'},
					{label:'知识产权超市',url:'/main/zscqzhfw/zscqcs'},
					{label:'质押融资服务',url:'/main/zscqzhfw/zyrzfw'},
					{label:'山东省新旧动能转换专利库',url:'http://123.233.248.189:8090/searchContent.html'}
				]
           },
           {
            name: '质量提升综合服务',
			labels:[
					{label:'计量服务',url:'/main/zltszhfw/jlfw'},
					{label:'标准服务',url:'/main/zltszhfw/bzfw'},
					{label:'认证认可',url:'/main/zltszhfw/rzfw'},
					{label:'质量及品牌',url:'/main/zltszhfw/zlypp'},
					{label:'培训服务',url:'http://123.233.248.189:8090/searchContent.html'}]
           },
           {
            name: '小微企业成长服务',
			labels:[
					{label:'小微企业查询',url:'/main/xwqyczfw/xwqycx'},
					{label:'党建引领',url:'/main/xwqyczfw/djyl'},
					{label:'文明诚信引领',url:'/main/xwqyczfw/wmcxyl'},
					{label:'融资服务',url:'/main/xwqyczfw/rzfw'},
					{label:'惠企政策查询',url:'/main/xwqyczfw/hqzc'},
					{label:'法律维权典型案例与分析',url:'/main/xwqyczfw/flwqdxalyfx'},
					{label:'人才对接',url:'main/xwqyczfw/rcdj'}
					]
           },
           {
            name: '检验检测服务',
			labels:[
					{label:'产品质量检测',url:'/main/jyjcfw/cpzljc'},
					{label:'食品检测',url:'http://sso.scjgj.weihai.gov.cn/'},
					{label:'计量检测',url:'http://scjgjjls.weihai.cn/cmiims/a/login;JSESSIONID=db6cae7597044f639205a804bee9f3fa'},
					{label:'特种设备检测',url:'/main/jyjcfw/tzsbjc'}
				]
			
           },

          ],
		  isActive:undefined,
		  
       
      };
    },
    created() {
		 
     this.nowTimes();
    },
    methods: {
		timeFormate(timeStamp) {
		
		    let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
		    let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
		    let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
		    this.nowTime = hh+":"+mm+':'+ss ;
		  },
      nowTimes(){
            this.timeFormate(new Date());
            setInterval(this.time,1000);
            this.clear()
          },
       clear(){
            clearInterval(this.time)
            this.time = null;
          },
     showPannel(item){		
		this.isActive=item;
		 
	 },
	  hidePannel(){
	  	this.isActive=false;
	  		 
	  },	
	  openUrl(url){
			// console.log("url====>",url);
		/*window.open(url);*/
	  },
    }
  }
</script>

<style scoped>
 
  .app-container {
     position: relative;    
     background-image: url("../../../assets/images/hkdt/bg.jpg");
	 background-size: 100% 100%;
	 width:100%;
	 height:880px;
	  display:cover;
   }
   .clock{
 
	   z-index: 9999999;
	   position: relative;
	   width: 120px;
	   height: 120px;
	   top: 16%;
	   left:4%;
   }
   .online{
   	   cursor: pointer;
   	   z-index: 9999;
   	   position: relative;   	    	    
   	   width: 90px;
   	   height: 40px;
   	   top: 30%;
   	   left:20%;
	   background-image: url("../../../assets/images/hkdt/online.png");
	   background-size: 100% 100%;	
   }
   .nvlPannel{   	    
   	   z-index: 9999;
   	   position: relative;
   	   padding:5px;
   	   text-align:center;
   	   width: 45%;
   	   height: 30%;
   	   top: 22%;
   	   left:35%;	  
   }
   .nvlPannel .content{   	    
   	   z-index: 9999;
   	   position:absolute;
   	   padding:15px;
   	   text-align:center;   	   
   	   height: 200px;
	   width: 100%;
	   background-image: url("../../../assets/images/hkdt/module_bg.png");
	   background-size: 100% 100%;	
	   cursor: pointer;
	 
   	  
   }
</style>